import type React from 'react';
import { Box, Stack, Text, Secondary } from 'braid-design-system';
import { observer } from 'mobx-react';
import DateFormat from '../../../common/DateFormat';
import * as styles from '../PreviousApplications.css';
import { linkPropsWithKeyboardNavigation } from 'src/utils/buildHandleEnterAndSpaceKeyPress';
import type { IProspect } from 'src/stores/JobApplicationStore/CandidateStore';
import useBucketLabel from 'src/utils/hooks/useBucketLabel';
import type { EmployerLocale } from 'src/siteConfig';
interface Props {
  previousApplication: IProspect;
  selectedPreviousApplication?: IProspect;
  selectPreviousApplication?: (previousApplicationId: string) => void;
  className?: string;
  locale: EmployerLocale;
}

const ListItem: React.FC<Props> = ({
  previousApplication,
  selectedPreviousApplication,
  selectPreviousApplication,
  className,
  locale,
}) => {
  const bucket = previousApplication.bucket;
  const { getLabelFromBucket } = useBucketLabel();
  return (
    <Box
      key={previousApplication.id}
      cursor="pointer"
      paddingY="large"
      className={className}
      {...linkPropsWithKeyboardNavigation(
        () =>
          selectPreviousApplication &&
          selectPreviousApplication(previousApplication.id),
      )}
    >
      <Stack space="small">
        <Text
          size="large"
          weight={
            previousApplication === selectedPreviousApplication
              ? 'strong'
              : 'regular'
          }
        >
          <Box
            className={styles.ellipsis}
            title={previousApplication.positionSummary.title}
          >
            {previousApplication.positionSummary.title}
          </Box>
        </Text>
        <Box display="flex">
          <Box marginRight="small">
            <Text>{getLabelFromBucket(bucket)}</Text>
          </Box>
          <Text>
            <Secondary>
              <DateFormat
                date={previousApplication.appliedDate}
                locale={locale}
              />
            </Secondary>
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};

export default observer(ListItem);
